import moment from 'moment'
import { omit, set } from 'lodash'

import config from '@/config'
import store from '@/redux/store'
import { resetState, openAddressFormModal } from '@/redux/ducks/supplier/edit'
import { PositionWithTaxCategory } from '@/modules/base/components/forms/positions-with-tax-category/index'
import SupplierService from '@/modules/supplier/supplierService'
import CustomerService from '@/modules/customer/customerService'
import { BankingService } from '@/modules/banking/services'
import { BASE_DATA_TYPES } from '@/modules/base/components/generics/constants'

const { dateFormat: { api: apiDateFormat } } = config

export const prepareOcrFillData = async(ocrData, dateFor, contactFormEnabled = true): Promise<any> => {
  const newOcrData = Object.assign({}, omit(ocrData, 'positions'))
  const filledData = []

  if (ocrData.date) {
    newOcrData.date = moment(ocrData.date).format(apiDateFormat)
    newOcrData.deliveryDate = newOcrData.date
  }
  if (contactFormEnabled && ocrData.payee) {
    newOcrData.payee = null
    store.dispatch(resetState())

    let suppliers = null

    try {
      ({ data: suppliers } = await SupplierService.find(ocrData.payee))
    } finally {
      if (suppliers?.length > 0) {
        newOcrData['supplierId'] = suppliers[0].id
        newOcrData['baseDataId'] = suppliers[0].id
        newOcrData['type'] = BASE_DATA_TYPES.SUPPLIER
        newOcrData['payee'] = ocrData.payee
        newOcrData['sender'] = ocrData.payee
        newOcrData['supplier'] = suppliers[0]
        filledData.push('supplierId')
      } else {
        let customers
        try {
          ({ data: customers } = await CustomerService.find(ocrData.payee))
        } finally {
          if (customers?.length > 0) {
            newOcrData['customerId'] = customers[0].id
            newOcrData['baseDataId'] = customers[0].id
            newOcrData['type'] = BASE_DATA_TYPES.CUSTOMER
            newOcrData['payee'] = ocrData.payee
            newOcrData['sender'] = ocrData.payee
            newOcrData['customer'] = customers[0]
            filledData.push('customerId')
          } else {
            store.dispatch(openAddressFormModal({ companyName: ocrData.payee, street: ocrData.payeeStreet, city: ocrData.payeeCity, zipCode: ocrData.payeeZipCode }, true))
            newOcrData['ocrPayee'] = ocrData.payee
          }
        }
      }
    }
  }

  if (ocrData.positions?.length) {
    newOcrData.positions = ocrData.positions
    filledData.push(...['priceTotal', 'priceNet', 'priceGross', 'vat', 'vatAmount'])
  } else if (ocrData.priceGross || ocrData.priceTotal || ocrData.priceNet) {
    const newPositions = PositionWithTaxCategory({
      totalGross: ocrData.priceGross || ocrData.priceTotal,
      totalNet: ocrData.priceNet,
      vatPercent: ocrData.vatRate,
      dateFor,
    })
    newOcrData.positions = [newPositions]
    filledData.push(...['priceTotal', 'priceNet', 'priceGross', 'vat', 'vatAmount'])
  }

  if (ocrData.payeeIban) {
    try {
      const { body: { data: { isIbanValid, bic } } } = await BankingService.checkIban(ocrData.payeeIban)

      if (isIbanValid) {
        set(newOcrData, 'supplier.bankAccounts[0].iban', ocrData.payeeIban)
        set(newOcrData, 'supplier.bankAccounts[0].bic', bic)
        set(newOcrData, 'supplier.bankAccounts[0].accountHolder', ocrData.payee)
      }
    } catch { }
  }

  Object.keys(newOcrData).forEach((key) => {
    if (
      newOcrData[key] == null
      || newOcrData[key] === ''
      || newOcrData[key] === 0
      || newOcrData[key] === '0.00'
      || newOcrData[key] === '0.0'
    ) {
      delete newOcrData[key]
    }
  })
  newOcrData.filledData = [...filledData, ...Object.keys(newOcrData)]
  return newOcrData
}
